// =============================================================================
// Project Policy Types (Phase 4: Policy Propagation)
// =============================================================================
/** Policy categories — what kind of policy this is. */
export const POLICY_CATEGORIES = ['rule', 'constraint', 'delegation', 'preference'];
/** Policy sources — how this policy was created. */
export const POLICY_SOURCES = ['explicit', 'inferred'];
/** Default values for policy configuration. */
export const POLICY_DEFAULTS = {
    maxPerProject: 100,
    titleMaxLength: 200,
    contentMaxLength: 2000,
    listPageSize: 50,
    listMaxPageSize: 200,
    defaultConfidence: 0.8,
};
export function isPolicyCategory(value) {
    return POLICY_CATEGORIES.includes(value);
}
export function isPolicySource(value) {
    return POLICY_SOURCES.includes(value);
}
//# sourceMappingURL=policy.js.map